import { updateItemInCollection } from "directus/src/operations";

// Add updateCompany function
export async function updateCompany({ item, companyId }) {
  try {
    const data = await updateItemInCollection("companies", companyId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
